import dom from "../../../../dist/jsx-render/dom"
import { WidgetController } from "../WidgetController";
import { SizerData } from "./SizerData";
import { SizerMode } from "./SizerMode";
import { WidgetBase } from "../Widgets/WidgetBase";

export class WidgetSizer {
    private leftTopSizer: HTMLElement;
    private topSizer: HTMLElement;
    private rightTopSizer: HTMLElement;
    private leftSizer: HTMLElement;
    private rightSizer: HTMLElement;
    private leftBottomSizer: HTMLElement;
    private bottomSizer: HTMLElement;
    private rightBottomSizer: HTMLElement;
    private sizerData: SizerData;

    constructor(private controller: WidgetController, private widget: WidgetBase, private element: HTMLElement) {
    }

    public create() {
        // left top sizer
        this.leftTopSizer = <div className="sizer sizer-left-top"></div>;
        this.element.appendChild(this.leftTopSizer);
        this.leftTopSizer.addEventListener("mousedown", this.onLeftTopSizerStart);

        // top sizer
        this.topSizer = <div className="sizer sizer-top"></div>;
        this.element.appendChild(this.topSizer);
        this.topSizer.addEventListener("mousedown", this.onTopSizerStart);

        // right top sizer
        this.rightTopSizer = <div className="sizer sizer-right-top"></div>;
        this.element.appendChild(this.rightTopSizer);
        this.rightTopSizer.addEventListener("mousedown", this.onRightTopSizerStart);

        // left sizer
        this.leftSizer = <div className="sizer sizer-left"></div>;
        this.element.appendChild(this.leftSizer);
        this.leftSizer.addEventListener("mousedown", this.onLeftSizerStart);

        // right sizer
        this.rightSizer = <div className="sizer sizer-right"></div>;
        this.element.appendChild(this.rightSizer);
        this.rightSizer.addEventListener("mousedown", this.onRightSizerStart);

        // left bottom sizer
        this.leftBottomSizer = <div className="sizer sizer-left-bottom"></div>;
        this.element.appendChild(this.leftBottomSizer);
        this.leftBottomSizer.addEventListener("mousedown", this.onLeftBottomSizerStart);

        // bottom sizer
        this.bottomSizer = <div className="sizer sizer-bottom"></div>;
        this.element.appendChild(this.bottomSizer);
        this.bottomSizer.addEventListener("mousedown", this.onBottomSizerStart);

        // right bottom sizer
        this.rightBottomSizer = <div className="sizer sizer-right-bottom"></div>;
        this.element.appendChild(this.rightBottomSizer);
        this.rightBottomSizer.addEventListener("mousedown", this.onRightBottomSizerStart);
    }

    public dispose(): void {
        this.leftTopSizer.parentElement.removeChild(this.leftTopSizer);
        this.topSizer.parentElement.removeChild(this.topSizer);
        this.rightTopSizer.parentElement.removeChild(this.rightTopSizer);
        this.leftSizer.parentElement.removeChild(this.leftSizer);
        this.rightSizer.parentElement.removeChild(this.rightSizer);
        this.leftBottomSizer.parentElement.removeChild(this.leftBottomSizer);
        this.bottomSizer.parentElement.removeChild(this.bottomSizer);
        this.rightBottomSizer.parentElement.removeChild(this.rightBottomSizer);
    }

    onRightSizerStart = (ev: MouseEvent) => {
        this.startSizer(ev, SizerMode.Right);
        this.controller.container.style.cursor = "ew-resize";
    }

    onLeftSizerStart = (ev: MouseEvent) => {
        this.startSizer(ev, SizerMode.Left);
        this.controller.container.style.cursor = "ew-resize";
    }

    onTopSizerStart = (ev: MouseEvent) => {
        this.startSizer(ev, SizerMode.Top);
        this.controller.container.style.cursor = "ns-resize";
    }

    onBottomSizerStart = (ev: MouseEvent) => {
        this.startSizer(ev, SizerMode.Bottom);
        this.controller.container.style.cursor = "ns-resize";
    }

    onLeftTopSizerStart = (ev: MouseEvent) => {
        this.startSizer(ev, SizerMode.LeftTop);
        this.controller.container.style.cursor = "nwse-resize";
    }

    onRightTopSizerStart = (ev: MouseEvent) => {
        this.startSizer(ev, SizerMode.RightTop);
        this.controller.container.style.cursor = "nesw-resize";
    }

    onRightBottomSizerStart = (ev: MouseEvent) => {
        this.startSizer(ev, SizerMode.RightBottom);
        this.controller.container.style.cursor = "nwse-resize";
    }

    onLeftBottomSizerStart = (ev: MouseEvent) => {
        this.startSizer(ev, SizerMode.LeftBottom);
        this.controller.container.style.cursor = "nesw-resize";
    }

    startSizer(ev: MouseEvent, mode: SizerMode) {
        ev.cancelBubble = true;
        ev.stopPropagation();
        ev.preventDefault();

        // listen on mousemove and mouseup
        document.addEventListener("mousemove", this.onDocumentMouseMove);
        document.addEventListener("mouseup", this.onDocumentMouseUp);

        this.sizerData = new SizerData(this.widget, mode);

        var rect = this.element.getBoundingClientRect();
        var parentRect = this.controller.container.getBoundingClientRect();

        this.sizerData.cellWidth = this.controller.getCellWidth();
        this.sizerData.cellHeight = this.controller.getCellHeight();
        this.sizerData.widthAdjust = (this.sizerData.cellWidth * this.widget.colSpan) - rect.width;
        this.sizerData.heightAdjust = (this.sizerData.cellHeight * this.widget.rowSpan) - rect.height;
        this.sizerData.parentLeft = parentRect.left;
        this.sizerData.parentTop = parentRect.top;

        this.controller.container.appendChild(this.sizerData.createElement(rect));
    }


    sizeRight(clientX: number, rectLeft: number): void {
        let width = clientX - rectLeft;
        this.sizerData.colSpan = Math.round(width / this.sizerData.cellWidth);
        if (this.sizerData.colSpan > this.widget.colSpan) {
            while (this.sizerData.colSpan > this.widget.colSpan && !this.isRightCellFree(this.sizerData.colSpan - 1)) {
                this.sizerData.colSpan--;
            }
        }
        else if (this.sizerData.colSpan < this.widget.minColSpan) {
            this.sizerData.colSpan = this.widget.minColSpan;
        }
    }

    sizeLeft(clientX: number): void {
        this.sizerData.column = Math.round((clientX - this.sizerData.parentLeft) / this.sizerData.cellWidth) + 1;
        this.sizerData.colSpan = this.widget.column - this.sizerData.column + this.widget.colSpan;
        if (this.sizerData.column < this.widget.column) {
            while (this.sizerData.column < this.widget.column && !this.isLeftCellFree(this.sizerData.column + 1)) {
                this.sizerData.column++;
                this.sizerData.colSpan--;
            }
        }
        else if (this.sizerData.colSpan < this.widget.minColSpan) {
            while (this.sizerData.colSpan < this.widget.minColSpan) {
                this.sizerData.colSpan++;
                this.sizerData.column--;
            }
        }
    }

    sizeTop(clientY: number): void {
        this.sizerData.row = Math.round((clientY - this.sizerData.parentTop) / this.sizerData.cellHeight) + 1;
        this.sizerData.rowSpan = this.widget.row - this.sizerData.row + this.widget.rowSpan;
        if (this.sizerData.row < this.widget.row) {
            while (this.sizerData.row < this.widget.row && !this.isTopCellFree(this.sizerData.row + 1)) {
                this.sizerData.row++;
                this.sizerData.rowSpan--;
            }
        }
        else if (this.sizerData.rowSpan < this.widget.minRowSpan) {
            while (this.sizerData.rowSpan < this.widget.minRowSpan) {
                this.sizerData.rowSpan++;
                this.sizerData.row--;
            }
        }
    }

    sizeBottom(clientY: number, rectTop: number): void {
        let height = clientY - rectTop;
        this.sizerData.rowSpan = Math.round(height / this.sizerData.cellHeight);
        if (this.sizerData.rowSpan > this.widget.rowSpan) {
            while (this.sizerData.rowSpan > this.widget.rowSpan && !this.isBottomCellFree(this.sizerData.rowSpan - 1)) {
                this.sizerData.rowSpan--;
            }
        }
        else if (this.sizerData.rowSpan < this.widget.minRowSpan) {
            this.sizerData.rowSpan = this.widget.minRowSpan;
        }
    }

    onDocumentMouseMove = (ev: MouseEvent) => {
        if (this.sizerData) {
            var rect = this.sizerData.element.getBoundingClientRect();

            switch (this.sizerData.mode) {
                case SizerMode.Right:
                    this.sizeRight(ev.clientX, rect.left);
                    break;
                case SizerMode.Left:
                    this.sizeLeft(ev.clientX);
                    break;
                case SizerMode.Top:
                    this.sizeTop(ev.clientY);
                    break;
                case SizerMode.Bottom:
                    this.sizeBottom(ev.clientY, rect.top);
                    break;
                case SizerMode.LeftTop:
                    this.sizeLeft(ev.clientX);
                    this.sizeTop(ev.clientY);
                    break;
                case SizerMode.LeftBottom:
                    this.sizeLeft(ev.clientX);
                    this.sizeBottom(ev.clientY, rect.top);
                    break;
                case SizerMode.RightTop:
                    this.sizeRight(ev.clientX, rect.left);
                    this.sizeTop(ev.clientY);
                    break;
                case SizerMode.RightBottom:
                    this.sizeRight(ev.clientX, rect.left);
                    this.sizeBottom(ev.clientY, rect.top);
                    break;
            }
            this.sizerData.resize();
        }
    }

    /**
     * Mouse up event handler.
     * @param ev Event data.
     */
    onDocumentMouseUp = (ev: MouseEvent) => {
        if (this.sizerData) {

            document.removeEventListener("mousemove", this.onDocumentMouseMove);
            document.removeEventListener("mouseup", this.onDocumentMouseUp);

            this.widget.column = this.sizerData.column;
            this.widget.row = this.sizerData.row;
            this.widget.colSpan = this.sizerData.colSpan;
            this.widget.rowSpan = this.sizerData.rowSpan;
            this.widget.setGridPosition();

            this.sizerData.element.parentElement.removeChild(this.sizerData.element);
            this.sizerData = null;

            this.controller.container.style.cursor = "";
        }
    }

    isLeftCellFree(column: number): boolean {
        for (let row = this.widget.row; row < this.widget.row + this.widget.rowSpan; row++) {
            if (!this.controller.isCellFree(column - 1, row)) {
                return false;
            }
        }
        return true;
    }

    isRightCellFree(colSpan: number): boolean {
        for (let row = this.widget.row; row < this.widget.row + this.widget.rowSpan; row++) {
            if (!this.controller.isCellFree(this.widget.column + colSpan, row)) {
                return false;
            }
        }
        return true;
    }

    isTopCellFree(row: number): boolean {
        for (let col = this.widget.column; col < this.widget.column + this.widget.colSpan; col++) {
            if (!this.controller.isCellFree(col, row - 1)) {
                return false;
            }
        }
        return true;
    }

    isBottomCellFree(rowSpan: number): boolean {
        for (let col = this.widget.column; col < this.widget.column + this.widget.colSpan; col++) {
            if (!this.controller.isCellFree(col, this.widget.row + rowSpan)) {
                return false;
            }
        }
        return true;
    }
}